<template>
  <div class="project-items">
    <section1 class="item"></section1>
    <section2 class="item"></section2>
    <section3 class="item"></section3>
    <section4 class="item"></section4>
  </div>
</template>

<script>
import Section1 from './Section1.vue'
import Section2 from './Section2.vue'
import Section3 from './Section3.vue'
import Section4 from './Section4.vue'
export default {
  name: 'ProjectAnalysis',
  components: {
    Section1,
    Section2,
    Section3,
    Section4
  },
  data() {
    return {}
  },
  computed: {
  },
  watch: {
  },
  created() {
    // do something
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.project-items {
  margin: -20px;
  padding: 20px;
  background: #F5F6FA;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* 两列，每列等分 */
  grid-template-rows: 283px 650px 674px;
  /* 三行，自动高度 */
  gap: 20px;
  padding-bottom: 20px;
}

.item {
  background: #FFFFFF;
  border-radius: 2px;
}

.item:nth-child(1) {
  grid-column: 1 / 3;
}

.item:nth-child(4) {
  grid-column: 1 / 3;
}
</style>
